import { render, staticRenderFns } from "./ConfigMail.vue?vue&type=template&id=2cef895c&scoped=true&"
import script from "./ConfigMail.vue?vue&type=script&lang=js&"
export * from "./ConfigMail.vue?vue&type=script&lang=js&"
import style0 from "./ConfigMail.vue?vue&type=style&index=0&id=2cef895c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cef895c",
  null
  
)

export default component.exports